export default "__VITE_ASSET__D13_gk0u__"